module.exports = __webpack_public_path__ + "img/sns_facebook.cdea3d5e.png";